import { TOAST_TYPES } from '@/constants/notificationTypes'
import { actions as flashActions } from '@/reducers/flashMessages'
import { taxAddressSelector } from '@/selectors'
import http from '@/utils/http'
import { routeFor } from '@/utils/router'
import { translate } from '@/utils/translations'

import { actions as taxActions } from '../taxes'
import cart from './index'

const { actions } = cart
const PROMO_CODE_GTM = 'gtm/promoCodeClick'
const VALID = 'valid'

export const updateTermsAcceptance = () => dispatch => {
  dispatch(actions.updateTermsAcceptanceStart())
  dispatch(flashActions.clearFlashMessages())

  return http.post(routeFor('apiStoreTermsAcceptances')).then(
    data => dispatch(actions.updateTermsAcceptanceSuccess(data))
  ).catch(
    error => {
      dispatch(actions.updateTermsAcceptanceFailure(error))
      dispatch(
        flashActions.setFlashMessages([{
          text: translate('errors.accept_terms_failure'),
          type: 'page_level_message_as_error'
        }])
      )
    }
  )
}

export const removePromoCode = () => (dispatch, state) => {
  const taxAddress = taxAddressSelector(state())
  dispatch(flashActions.clearFlashMessages())

  dispatch(actions.removePromoCodeStart())
  dispatch(taxActions.calculateTaxesStart())

  return http.post(
    routeFor('removeApiPromoCodes',
      {
        tax_address: {
          city: taxAddress.city,
          country: taxAddress.country,
          postal_code: taxAddress.postalCode,
          state: taxAddress.state
        }
      }
    ),
  ).then(
    response => {
      dispatch(actions.removePromoCodeSuccess(response))
      dispatch(taxActions.calculateTaxesSuccess())
      dispatch(flashActions.notifyWithToast({
        message: translate('promo_code.notice.promo_code_removed'),
        type: TOAST_TYPES.notice
      }))
      document.getElementById('promo_code[promo_code]').focus()
    }
  ).catch(
    error => {
      dispatch(actions.removePromoCodeFailure(error))
      dispatch(taxActions.calculateTaxesFailure())
      dispatch(flashActions.clearFlashMessages())
      dispatch(flashActions.notifyWithToast({
        message: error.message,
        type: TOAST_TYPES.error
      }))
    }
  )
}

export const applyPromoCode = ({ value }) => (dispatch, state) => {
  const taxAddress = taxAddressSelector(state())
  dispatch(flashActions.clearFlashMessages())

  dispatch(actions.applyPromoCodeStart())
  dispatch(taxActions.calculateTaxesStart())

  return http.post(
    routeFor('applyApiPromoCodes',
      {
        promo_code: value,
        tax_address: {
          city: taxAddress.city,
          country: taxAddress.country,
          postal_code: taxAddress.postalCode,
          state: taxAddress.state
        }
      }),
  ).then(
    response => {
      dispatch(actions.applyPromoCodeSuccess(response))
      dispatch(taxActions.calculateTaxesSuccess())
      document.getElementById('applied-promo-code').focus()
      dispatch({
        payload: { promoCodeInput: value, promoCodeStatus: VALID },
        type:  PROMO_CODE_GTM
      })
    }
  ).catch(
    ({ responseData }) => {
      dispatch(actions.applyPromoCodeFailure(responseData))
      dispatch(taxActions.calculateTaxesFailure())
      dispatch({
        payload: {
          promoCodeInput: value, promoCodeStatus: responseData.error
        },
        type:  PROMO_CODE_GTM
      })
    }
  )
}
